<template>
    <div class="vibe-about">
        <!-- Hero Image -->
        <section class="container my-16">
            <div class="relative h-[500px] w-full">
                <img
                    aria-label="About VIBE"
                    class="size-full rounded-2xl object-cover"
                    src="@/assets/images/team/aboutus_hero.jpg"
                />
            </div>
        </section>

        <!-- Team Section -->
        <section class="container mb-16">
            <div class="mb-12 flex items-center justify-center px-16 max-md:px-5">
                <h2 class="text-4xl font-bold text-[#282828]">Meet Vibe team members</h2>
                <div class="ml-4 flex gap-2">
                    <img alt="Decorative star" src="@/assets/images/vibe/stars.png" />
                </div>
            </div>

            <div class="px-16 max-md:px-5">
                <div class="grid grid-cols-1 gap-8 md:grid-cols-2">
                    <div class="relative aspect-[417/592] w-full">
                        <img
                            alt="Javier Esteves"
                            class="size-full rounded-2xl object-cover"
                            src="@/assets/images/team/javier.jpg"
                        />
                        <div class="bg-opacity/90 absolute inset-x-4 bottom-8 rounded-xl bg-white p-4 dark:bg-surface-card">
                            <h3 class="mb-0.5 text-lg font-bold text-[#282828]">Javier Esteves</h3>
                            <p class="mb-2 text-base text-[#4D4AFB]">Project Manager</p>
                            <p class="text-sm leading-relaxed text-[#282828]">
                                He was born in Argentina, but lives in Denmark since 2017. In his experience, so many
                                people have been a mentor for him without them really knowing about it. Their help
                                supported Javier to do his own projects and have a community in Aarhus. His goal with
                                VIBE is to make it easier for many more people to connect and help each other grow.
                            </p>
                        </div>
                    </div>

                    <div class="relative aspect-[417/592] w-full">
                        <img
                            alt="Adela Kucovska"
                            class="size-full rounded-2xl object-cover"
                            src="@/assets/images/team/adela.jpg"
                        />
                        <div class="bg-opacity/90 absolute inset-x-4 bottom-8 rounded-xl bg-white p-4 dark:bg-surface-card">
                            <h3 class="mb-0.5 text-lg font-bold text-[#282828]">Adela Kucovska</h3>
                            <p class="mb-2 text-base text-[#4D4AFB]">Project Coordinator</p>
                            <p class="text-sm leading-relaxed text-[#282828]">
                                She moved to Denmark from Slovakia 5 years ago to study. One of the most eye opening
                                moments for her happened during a spontaneous mentoring session with her professor. She
                                is driven to encourage young people to become VIBE Mentors to share their passion and
                                document every step of these unique journeys.
                            </p>
                        </div>
                    </div>

                    <div class="relative aspect-[417/592] w-full">
                        <img
                            alt="Laura Kulpaviciute"
                            class="size-full rounded-2xl object-cover"
                            src="@/assets/images/team/laura.jpg"
                        />
                        <div class="bg-opacity/90 absolute inset-x-4 bottom-8 rounded-xl bg-white p-4 dark:bg-surface-card">
                            <h3 class="mb-0.5 text-lg font-bold text-[#282828]">Laura Kulpaviciute</h3>
                            <p class="mb-2 text-base text-[#4D4AFB]">UX/UI designer</p>
                            <p class="text-sm leading-relaxed text-[#282828]">
                                She is passionate about digital design and holds a bachelor's degree in multimedia
                                design. A mentor helped guide her career aspirations, and through VIBE, her goal is to
                                connect people with similar interests, share knowledge, and foster friendships.
                            </p>
                        </div>
                    </div>

                    <div class="relative aspect-[417/592] w-full">
                        <img
                            alt="Magnus Mosholm"
                            class="size-full rounded-2xl object-cover"
                            src="@/assets/images/team/magnus.jpg"
                        />
                        <div class="bg-opacity/90 absolute inset-x-4 bottom-8 rounded-xl bg-white p-4 dark:bg-surface-card">
                            <h3 class="mb-0.5 text-lg font-bold text-[#282828]">Magnus Mosholm</h3>
                            <p class="mb-2 text-base text-[#4D4AFB]">Project Coordinator</p>
                            <p class="text-sm leading-relaxed text-[#282828]">
                                Since his early days Magnus has connected his experience and passion in the creative
                                field with leading involvement in different projects and utilized it to create healthier
                                environments and better circumstances for young people to grow with their ambitions and
                                values. He is especially passionate about making purposeful connections between people.
                            </p>
                        </div>
                    </div>

                    <div class="relative aspect-[417/592] w-full">
                        <img
                            alt="Relo"
                            class="size-full rounded-2xl object-cover"
                            src="@/assets/images/team/relo.jpg"
                        />
                        <div class="bg-opacity/90 absolute inset-x-4 bottom-8 rounded-xl bg-white p-4 dark:bg-surface-card">
                            <h3 class="mb-0.5 text-lg font-bold text-[#282828]">Relo</h3>
                            <p class="mb-2 text-base text-[#4D4AFB]">Frontend Developer</p>
                            <p class="text-sm leading-relaxed text-[#282828]">
                                He has been growing together with GROWNi.sk since its very beginnings (2020). He is
                                responsible for the technical part and development. Various tech toys are also part of
                                his work including Google Cloud, Firebase, Github, Bloomreach.
                            </p>
                        </div>
                    </div>

                    <div class="relative aspect-[417/592] w-full">
                        <img alt="Lia" class="size-full rounded-2xl object-cover" src="@/assets/images/team/lia.jpg" />
                        <div class="bg-opacity/90 absolute inset-x-4 bottom-8 rounded-xl bg-white p-4 dark:bg-surface-card">
                            <h3 class="mb-0.5 text-lg font-bold text-[#282828]">Lia</h3>
                            <p class="mb-2 text-base text-[#4D4AFB]">Project Coordinator</p>
                            <p class="text-sm leading-relaxed text-[#282828]">
                                She has experience in tourism, where she has guided companies in development, marketing,
                                and branding. She helps businesses leverage data to gain valuable insights that can be
                                transformed into actionable knowledge. She is particularly passionate about DEI and ESG
                                and how these principles can be effectively integrated into companies and organizations.
                            </p>
                        </div>
                    </div>

                    <div class="relative aspect-[417/592] w-full">
                        <img
                            alt="Viktoria"
                            class="size-full rounded-2xl object-cover"
                            src="@/assets/images/team/viki.jpg"
                        />
                        <div class="bg-opacity/90 absolute inset-x-4 bottom-8 rounded-xl bg-white p-4 dark:bg-surface-card">
                            <h3 class="mb-0.5 text-lg font-bold text-[#282828]">Viktoria</h3>
                            <p class="mb-2 text-base text-[#4D4AFB]">Project Coordinator</p>
                            <p class="text-sm leading-relaxed text-[#282828]">
                                She discovered the non-profit sector during her secondary school studies through
                                educational programmes such as DofE. She studied European Studies and worked on various
                                projects in non-profit organisations. Throughout her journey, she had several mentors
                                and mentees who have helped her to move forward. At GROWN, she is responsible for
                                mentoring and volunteering.
                            </p>
                        </div>
                    </div>

                    <div class="relative aspect-[417/592] w-full">
                        <img
                            alt="Baška"
                            class="size-full rounded-2xl object-cover"
                            src="@/assets/images/team/basa.jpg"
                        />
                        <div class="bg-opacity/90 absolute inset-x-4 bottom-8 rounded-xl bg-white p-4 dark:bg-surface-card">
                            <h3 class="mb-0.5 text-lg font-bold text-[#282828]">Baška</h3>
                            <p class="mb-2 text-base text-[#4D4AFB]">Project Coordinator</p>
                            <p class="text-sm leading-relaxed text-[#282828]">
                                With a sociology background from Comenius University, Baška has lived in Sweden and
                                Australia before returning to Slovakia to join LEAF. She worked in Operations and later
                                in the Expert Volunteer Program, now part of GROWNi. At GROWNi, she focuses on
                                developing the volunteer section and data analysis, helping connect professionals with
                                meaningful opportunities.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <VibeMentorshipChoiceSection />
    </div>
</template>

<script setup lang="ts">
import VibeMentorshipChoiceSection from '@/components/vibe/VibeMentorshipChoiceSection.vue'

definePageMeta({
    layout: 'landingpagevibe'
})

useHead({
    title: 'About Us | Vibe',
    meta: [
        {
            name: 'description',
            content: 'Learn more about Vibe, our mission, vision, and the community we are building through mentorship.'
        }
    ]
})
</script>
